import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function About() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow">
        <div className="container mx-auto px-4 py-8">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl font-bold mb-8 text-center">About AI Tools Hub</h1>
            
            <div className="grid md:grid-cols-2 gap-12 mb-12">
              <div>
                <h2 className="text-2xl font-semibold mb-4">Our Mission</h2>
                <p className="text-gray-600 mb-6">
                  AI Tools Hub is dedicated to providing users with the most comprehensive and practical AI tools navigation service. 
                  We carefully select and review every AI tool to help users find the most suitable solutions.
                </p>
                
                <h2 className="text-2xl font-semibold mb-4">Website Features</h2>
                <ul className="space-y-2 text-gray-600">
                  <li className="flex items-start">
                    <i className="fa-solid fa-check text-green-500 mt-1 mr-2"></i>
                    Curated high-quality AI tools, regularly updated
                  </li>
                  <li className="flex items-start">
                    <i className="fa-solid fa-check text-green-500 mt-1 mr-2"></i>
                    Professional reviews and usage recommendations
                  </li>
                  <li className="flex items-start">
                    <i className="fa-solid fa-check text-green-500 mt-1 mr-2"></i>
                    Smart categorization and search functionality
                  </li>
                  <li className="flex items-start">
                    <i className="fa-solid fa-check text-green-500 mt-1 mr-2"></i>
                    Continuous tracking of AI industry trends
                  </li>
                </ul>
              </div>
              
              <div>
                <h2 className="text-2xl font-semibold mb-4">Why Choose Us</h2>
                <div className="space-y-4">
                  <div className="bg-blue-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-blue-800 mb-2">Professional Reviews</h3>
                    <p className="text-blue-600 text-sm">
                      Our team thoroughly tests each tool, providing genuine user experiences and recommendations
                    </p>
                  </div>
                  <div className="bg-green-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-green-800 mb-2">Timely Updates</h3>
                    <p className="text-green-600 text-sm">
                      We continuously monitor the latest AI developments and update tool information immediately
                    </p>
                  </div>
                  <div className="bg-purple-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-purple-800 mb-2">User-Friendly</h3>
                    <p className="text-purple-600 text-sm">
                      Clean and intuitive interface design that helps you quickly find the tools you need
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-r from-blue-50 to-purple-50 p-8 rounded-lg">
              <h2 className="text-2xl font-semibold mb-4 text-center">Statistics</h2>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
                <div>
                  <div className="text-3xl font-bold text-blue-600 mb-2">33+</div>
                  <div className="text-gray-600">Curated AI Tools</div>
                </div>
                <div>
                  <div className="text-3xl font-bold text-green-600 mb-2">10+</div>
                  <div className="text-gray-600">Main Categories</div>
                </div>
                <div>
                  <div className="text-3xl font-bold text-purple-600 mb-2">24/7</div>
                  <div className="text-gray-600">Continuous Updates</div>
                </div>
                <div>
                  <div className="text-3xl font-bold text-orange-600 mb-2">Free</div>
                  <div className="text-gray-600">Completely Free</div>
                </div>
              </div>
            </div>

            <div className="mt-12 text-center">
              <h2 className="text-2xl font-semibold mb-4">Support Us</h2>
              <p className="text-gray-600 mb-6">
                This website is completely free to use. If you find our content valuable, you can support us in the following ways:
              </p>
              <div className="flex justify-center space-x-4">
                <div className="bg-white p-4 rounded-lg shadow text-center">
                  <i className="fa-solid fa-share text-2xl text-blue-500 mb-2"></i>
                  <p className="text-sm">Share with friends</p>
                </div>
                <div className="bg-white p-4 rounded-lg shadow text-center">
                  <i className="fa-solid fa-heart text-2xl text-red-500 mb-2"></i>
                  <p className="text-sm">Bookmark our site</p>
                </div>
                <div className="bg-white p-4 rounded-lg shadow text-center">
                  <i className="fa-solid fa-shopping-cart text-2xl text-green-500 mb-2"></i>
                  <p className="text-sm">Purchase via our links</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}